import React, { useState, useEffect } from "react";
import * as apiClient from "../../common/apiClient";
import * as apiMethod from "../../common/apiMethod";
import * as appModule from "../../common/appModule";
import Spinner from "../Spinner/Spinner";
import "./comment.css";
const Comment = (props) => {
  const [message, setMessage] = useState("");
  const [post, setPost] = useState("");
  const [addingPost, setAddingPost] = useState(false);
  const [loadingPost, setLoadingPost] = useState(false);
  const [postData, setPostData] = useState([]);

  useEffect(() => {
    loadingPosts();
  }, []);
  const handlePost = async () => {
    if (post.trim().length === 0) {
      setMessage("Please enter comment ");
      return;
    }
    let formBody = {
      id: 0,
      moduleCode: props.moduleCode,
      commentCode: "",
      uniqueCode: props.uniqueCode,
      comment: post,
      attachmentURL: "",
    };
    setAddingPost(true);
    apiClient
      .post(
        `${apiClient.baseUrl}${appModule.masterModule}${apiMethod.createComment}`,
        formBody
      )
      .then((response) => {
        if (response.IsSuccess) {
          setPost("");
          loadingPosts();
        } else {
          setMessage(response.Message);
        }
        setAddingPost(false);
      })
      .catch((err) => {
        setMessage(err);
        setAddingPost(false);
      });
  };
  const loadingPosts = async () => {
    let formBody = {
      moduleCode: props.moduleCode,
      uniqueCode: props.uniqueCode,
    };
    setLoadingPost(true);
    apiClient
      .post(
        `${apiClient.baseUrl}${appModule.masterModule}${apiMethod.getComments}`,
        formBody
      )
      .then((response) => {
        if (response.IsSuccess) {
          setPostData(response.ResultSet.ResultList);
        } else {
          setMessage(response.Message);
        }
        setLoadingPost(false);
      })
      .catch((err) => {
        setMessage(err);
        setLoadingPost(false);
      });
  };

  return (
    <div className="post-container">
      <div className="comment-wrapper">
        <div className="panel panel-info">
          {/* <div className="panel-heading"> Comment panel</div> */}
          <div className="panel-body">
            {props.hideSection ? (
              ""
            ) : (
              <>
                <div className="cmn-input-box">
                  <textarea
                    className="form-control"
                    value={post}
                    placeholder="write a comment..."
                    rows="3"
                    style={{ height: "117px", width: "722px;" }}
                    onChange={(event) => {
                      setPost(event.target.value);
                      if (event.target.value.length > 0) {
                        setMessage("");
                      }
                    }}
                  ></textarea>

{!addingPost&& <button
                    type="button"
                    onClick={handlePost}
                    className="btn btn-info"
                  >
                    Post
                  </button>}
                  {addingPost&& <button
                    type="button"
                    onClick={()=>{}}
                    className="btn btn-info"
                  >
                    Wait..
                  </button>}
                </div>
              </>
            )}

            <div className="clearfix">
              <span
                style={{ color: "red", fontSize: "larger", fontWeight: "bold" }}
              >
                {message}
              </span>
              <br />
            </div>

            {loadingPost && <Spinner />}
            <ul className="media-list">
              {!loadingPost &&
                postData.map((item) => {
                  return (
                    <li className="media">
                      {" "}
                      {/* <a href="#" className="pull-left">
                        {" "}
                        <img
                          src="https://bootdey.com/img/Content/user_2.jpg"
                          alt=""
                          className="img-circle"
                        />{" "}
                      </a> */}
                      <div className="media-body">
                        {" "}
                        <span className="text-muted pull-right">
                          {" "}
                          <small className="text-muted">
                            {item.CreateDate}
                          </small>{" "}
                        </span>{" "}
                        <strong className="text-success">
                          {item.CreatedBy}
                        </strong>
                        <p> {item.Comment}</p>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Comment;
